import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { ControlledTextField } from 'components/shared';

import { EmployerSelect } from './EmployerSelect';

export const EmployerFields = () => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.general'
  });

  const handleSelect = (value, label) => {
    setValue('nameBrief', label);
  };

  return (
    <>
      <Grid item xs={12}>
        <EmployerSelect handleSelect={handleSelect} />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          variant="outlined"
          name="nameBrief"
          disabled
          label={t('employer_name_short_label')}
        />
      </Grid>
    </>
  );
};
